module.exports = __webpack_public_path__ + "img/logo_navigation_app.3bf80846.png";